import { ref, computed } from '@vue/composition-api';
import { useStore } from '@/core/store';

export default function useGetBookingStationTime (bookingId) {
  const store = useStore();
  const bookingStationTimesChanges = ref({});

  const bookingStationTimesInStore = computed(() => {
    const booking = store.getters['entities/Booking'](bookingId);
    return (booking) ? booking.bookingStationTimes : [];
  });

  const bookingStationTimes = computed(() => {
    const bookingStationTimesInStoreWithUpdated = bookingStationTimesInStore.value.map(bookingStationTime => {
      const changes = bookingStationTimesChanges.value[bookingStationTime.id];
      if (changes) return { ...bookingStationTime, ...changes, _id: bookingStationTime.id };
      return { ...bookingStationTime, ...changes, _id: bookingStationTime.id };
    });
    const newBookingStationTimes = Object.values(bookingStationTimesChanges.value).filter(bookingStationTime => bookingStationTime._id.includes('new'));
    return [...bookingStationTimesInStoreWithUpdated, ...newBookingStationTimes];
  });

  return {
    bookingStationTimesChanges,
    bookingStationTimesInStore,
    bookingStationTimes,
  };
}
